module.exports = __webpack_public_path__ + "static/media/pricing3.d80900b3.png";